// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"755f6dd6","328":"ebebf12f","414":"122932aa","551":"5643f081","697":"44f2468c"}[chunkId] + ".chunk.css";
};